import { render } from "./TheTopHeaderDropDownMenuProfileEditProfileModalChangePasswordModal.vue?vue&type=template&id=486d0a44"
import script from "./TheTopHeaderDropDownMenuProfileEditProfileModalChangePasswordModal.vue?vue&type=script&lang=js"
export * from "./TheTopHeaderDropDownMenuProfileEditProfileModalChangePasswordModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__